// Directly import mocks from header-app
import { handlers as commonVendorHandlers } from "@catchoftheday/common-vendors";
import { handlers as headerAppHandlers } from "@catchoftheday/header-app";
import { cartHandlers } from "./cart";
import { checkoutHandlers } from "./checkout";
import { locationSelectorHandlers } from "./location-selector";
import { loginFormHandler } from "./loginForm";
import { localDevHandler } from "./localDevHandler";

export const handlers = [
  ...cartHandlers,
  ...(commonVendorHandlers || []),
  ...(headerAppHandlers || []),
  ...checkoutHandlers,
  ...locationSelectorHandlers,
  ...loginFormHandler,
  // handlers for local dev environment
  ...localDevHandler,
];
